<template>
  <div class="nch--blog-post">
    <div class="nch--blog-container">
      <Card class="nch--blog-content">
        <Breadcrumb :items="breadcrumb" />
        <Header :value="post" />
        <article v-html="post.translation.content" class="ql-editor"></article>
        <Tags :value="post.tags" :post="post" />
        <Share :post="post" v-if="mobile" />
        <Categories v-if="mobile"/>
        <Comments
          v-if="!preview && post.has_comments"
          :post="post"
          :user="user"
        />
      </Card>
      <Aside v-if="!mobile" :post="post" />
    </div>
  </div>
</template>

<script>
import Card from '../../common/Card';
import Breadcrumb from '../../common/Breadcrumb';
import Comments from './Comments';
import Tags from './Tags';
import Header from './Header';
import Aside from '../../Aside';
import Share from '../../Aside/Share';
import Categories from '../../Aside/Categories';
import theme from '../../../mixins/theme';
import responsive from '../../../mixins/responsive';

export default {
  name: 'Post',
  components: {
    Card,
    Header,
    Breadcrumb,
    Comments,
    Tags,
    Aside,
    Share,
    Categories,
  },
  mixins: [
    theme,
    responsive,
  ],
  props: {
    user: {
      type: Object,
      description: 'Nochalks user object',
    },
    preview: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
      description: 'Post object',
    },
    settings: {
      type: Object,
      default: () => ({
        title: 'Blog',
      }),
    },
  },
  data() {
    const category = this.value.category.translation;
    return {
      breadcrumb: [
        { name: this.settings.title, href: '/blog' },
        { name: category.name, href: `/blog/category/${category.slug}` },
      ],
    };
  },
  computed: {
    post: {
      get() {
        return this.value;
      },
      set(post) {
        this.$emit('input', post);
      },
    },
    mobile() {
      return this.sm || this.xs;
    },
  },
};
</script>

<style scoped>
.nch--blog-post {
  display: flex;
  align-items: center;
  justify-content: center;
}
.nch--blog-container {
  display: grid;
  width: var(--blog-container-width);
  grid-template-columns: 1fr auto;
  grid-template-areas: "content aside";
}
.nch--blog-content{
  display: flex;
  flex-direction: column;
}
.nch--blog-content article {
  margin: 2rem 0;
  letter-spacing: 0.003em;
  word-spacing: 0.003em;
  line-height: 1.4;
  text-align: justify;
  font-size: 1.2rem;
}
@media (max-width: 900px) {
  .nch--blog-container {
    display: flex;
    flex-direction: column;
  }
}
</style>
<style>
.nch--blog-post * {
  font-family: var(--blog-font-family);
}
.nch--blog-post article img,
.nch--blog-post article iframe {
  max-width: 100%;
}
</style>
